/**
 * L1 统一响应信封解析
 * 供 shared/request 与 CollabCore 共用
 */

import { parseL1Error } from './l1-error'

/** L1 成功码 */
export const L1_SUCCESS_CODE = 1000

/** L1 响应信封 */
export interface L1Response<T = unknown> {
  code: number
  message: string
  data: T | null
}

/** 需要抛出 L1Error 的业务错误码（与 Collab 错误码语义对齐） */
const THROWABLE_CODES = new Set<number>([
  4010,
  4030,
  4040,
  4220,
  5000,
  4001,
  4002,
  4003,
  4011,
  4006,
  4007,
  4008,
  4041,
  4090,
  4091,
  5030,
  5031,
  4291,
  4292,
])

/**
 * 判断 payload 是否为 L1 响应信封形状
 */
export function isL1Envelope(payload: unknown): payload is L1Response {
  return (
    payload !== null &&
    typeof payload === 'object' &&
    'code' in payload &&
    typeof (payload as L1Response).code === 'number' &&
    'message' in payload &&
    typeof (payload as L1Response).message === 'string'
  )
}

/**
 * 解析 L1 响应信封
 * code === 1000 返回 data；标准错误码抛出 L1Error
 */
export function unwrapL1Response<T>(payload: unknown): T {
  if (isL1Envelope(payload)) {
    if (payload.code === L1_SUCCESS_CODE) {
      return payload.data as T
    }
    if (THROWABLE_CODES.has(payload.code)) {
      throw parseL1Error(payload, 200)
    }
  }
  return payload as T
}
